"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clientShow = clientShow;
exports.show = show;
exports.showMobile = showMobile;
exports.default = exports.AnimatedContainer = exports.MobileSiteNavigation = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = babelHelpers.interopRequireDefault(require("react-dom"));

var _decorators = require("decorators");

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _search = _interopRequireWildcard(require("modals/search"));

var _Button = babelHelpers.interopRequireDefault(require("components/Notifications/Button"));

var _Listener = babelHelpers.interopRequireDefault(require("components/Notifications/Listener"));

var _UserProfile = babelHelpers.interopRequireDefault(require("components/UserProfile"));

var _logout = require("logout");

var _LoginForm = require("components/LoginForm");

var _userProfile = require("user-profile");

var _animationHelper = babelHelpers.interopRequireDefault(require("animation-helper"));

var _noty = require("noty");

var _PaymentsModal = require("components/PaymentsModal");

var _PaymentMethodsModal = require("components/PaymentMethodsModal");

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _eventDispatcher = babelHelpers.interopRequireDefault(require("event-dispatcher"));

var _SiteLayout = babelHelpers.interopRequireDefault(require("layouts/SiteLayout"));

var _Viewer = require("components/Notifications/Viewer");

var _localize = require("localize");

var _ProfileImageContainer = babelHelpers.interopRequireDefault(require("components/ProfileImageContainer"));

var _excluded = ["items"],
    _excluded2 = ["feed", "items"];

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _class3, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _class5, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || babelHelpers.typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = babelHelpers.getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = babelHelpers.getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return babelHelpers.possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function clientShow(props) {
  show(document.querySelector('#nav-container'), props);
}

function show(parent, props) {
  var SiteNavigation = require('components/SiteNavigation').default;

  _reactDom.default.render( /*#__PURE__*/_react.default.createElement(SiteNavigation, props), parent);
}

function showMobile(parent, props) {
  var MobileSiteNavigation = require('components/SiteNavigation').MobileSiteNavigation;

  _reactDom.default.render( /*#__PURE__*/_react.default.createElement(MobileSiteNavigation, props), parent);
}

var MobileSiteNavigation = (_class = /*#__PURE__*/function (_Component) {
  babelHelpers.inherits(MobileSiteNavigation, _Component);

  var _super = _createSuper(MobileSiteNavigation);

  function MobileSiteNavigation() {
    var _this;

    babelHelpers.classCallCheck(this, MobileSiteNavigation);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    babelHelpers.initializerDefineProperty(_this, "signUpText", _descriptor, babelHelpers.assertThisInitialized(_this));
    babelHelpers.initializerDefineProperty(_this, "signInText", _descriptor2, babelHelpers.assertThisInitialized(_this));
    babelHelpers.initializerDefineProperty(_this, "userProfile", _descriptor3, babelHelpers.assertThisInitialized(_this));
    babelHelpers.initializerDefineProperty(_this, "hasCreateAccount", _descriptor4, babelHelpers.assertThisInitialized(_this));
    _this.state = {
      profile: _this.userProfile
    };
    return _this;
  }

  babelHelpers.createClass(MobileSiteNavigation, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      $(document).on('profileUpdated', function (event) {
        _this2.setState({
          profile: event.profile
        });
      });
      if (!this.state.profile) this.updateProfile(null);
    }
  }, {
    key: "updateProfile",
    value: function updateProfile(state) {
      var _this3 = this;

      if (state && state.modal) state.modal.hide();

      if (state && state.useCustomHome && location.href.split('?').shift() == state.defaultHome) {
        if (history.pushState) {
          history.pushState({}, "", state.useCustomHome);
        }
      }

      (0, _userProfile.userProfileUpdated)(state && state.loggedOut === true).then(function (profile) {
        if (state) {
          var evt;
          if (state.isNewAccount === true) evt = 'account-created';else if (state.isNewAccount === false) evt = 'signed-in';

          if (evt) {
            (0, _eventDispatcher.default)(evt, profile);
          }
        }

        _this3.setState(function (st) {
          return {
            profile: profile,
            menuOpen: st.menuOpen === true || st.menuOpen === false ? false : null
          };
        });
      });
    }
  }, {
    key: "logout",
    value: function logout(event) {
      (0, _logout.doLogout)().then(this.loggedOut).then(this.updateProfile);
    }
  }, {
    key: "loggedOut",
    value: function loggedOut(value) {
      (0, _noty.showNotificationText)('You have been signed out.');
      return {
        loggedOut: true
      };
    }
  }, {
    key: "showSignUp",
    value: function showSignUp(event) {
      _SiteLayout.default.current.hideSideNav();

      (0, _LoginForm.show)('sign-up').then(this.updateProfile);
    }
  }, {
    key: "showSignIn",
    value: function showSignIn(event) {
      _SiteLayout.default.current.hideSideNav();

      (0, _LoginForm.show)('sign-in').then(this.updateProfile);
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.profile && !this.state.profile.guest) {
        return null;
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "mobile-button-container"
      }, /*#__PURE__*/_react.default.createElement("a", {
        title: "Sign In",
        className: "mobile-btn sign-in",
        href: "javascript:void(0)",
        onClick: this.showSignIn
      }, /*#__PURE__*/_react.default.createElement("p", null, this.signInText || 'Sign In')), this.hasCreateAccount && /*#__PURE__*/_react.default.createElement("a", {
        title: "Sign Up",
        className: "mobile-btn sign-up",
        href: "javascript:void(0)",
        onClick: this.showSignUp
      }, /*#__PURE__*/_react.default.createElement("p", null, this.signUpText || 'Sign Up')));
    }
  }]);
  return MobileSiteNavigation;
}(_react.Component), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "signUpText", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "signInText", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "userProfile", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "hasCreateAccount", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), babelHelpers.applyDecoratedDescriptor(_class.prototype, "updateProfile", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "updateProfile"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "logout", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "logout"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "loggedOut", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "loggedOut"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "showSignUp", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "showSignUp"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "showSignIn", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "showSignIn"), _class.prototype)), _class);
exports.MobileSiteNavigation = MobileSiteNavigation;
var AnimatedContainer = (_class3 = /*#__PURE__*/function (_Component2) {
  babelHelpers.inherits(AnimatedContainer, _Component2);

  var _super2 = _createSuper(AnimatedContainer);

  function AnimatedContainer() {
    var _this4;

    babelHelpers.classCallCheck(this, AnimatedContainer);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this4 = _super2.call.apply(_super2, [this].concat(args));
    babelHelpers.initializerDefineProperty(_this4, "speed", _descriptor5, babelHelpers.assertThisInitialized(_this4));
    babelHelpers.initializerDefineProperty(_this4, "delayEnter", _descriptor6, babelHelpers.assertThisInitialized(_this4));
    babelHelpers.initializerDefineProperty(_this4, "delayExit", _descriptor7, babelHelpers.assertThisInitialized(_this4));
    babelHelpers.initializerDefineProperty(_this4, "entrance", _descriptor8, babelHelpers.assertThisInitialized(_this4));
    babelHelpers.initializerDefineProperty(_this4, "exit", _descriptor9, babelHelpers.assertThisInitialized(_this4));
    babelHelpers.initializerDefineProperty(_this4, "style", _descriptor10, babelHelpers.assertThisInitialized(_this4));
    babelHelpers.initializerDefineProperty(_this4, "mode", _descriptor11, babelHelpers.assertThisInitialized(_this4));
    babelHelpers.initializerDefineProperty(_this4, "children", _descriptor12, babelHelpers.assertThisInitialized(_this4));
    babelHelpers.initializerDefineProperty(_this4, "className", _descriptor13, babelHelpers.assertThisInitialized(_this4));
    babelHelpers.initializerDefineProperty(_this4, "id", _descriptor14, babelHelpers.assertThisInitialized(_this4));
    _this4.state = {
      // Current: out, entering, in, exiting
      current: 'out',
      // Target: out, in
      target: 'out'
    };
    return _this4;
  }

  babelHelpers.createClass(AnimatedContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.mode == 'in') {
        this.setState({
          target: 'in'
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.mode != this.props.mode) {
        switch (this.mode) {
          case 'out':
          default:
            this.setState({
              target: 'out'
            });
            break;

          case 'in':
            this.setState({
              target: 'in'
            });
            break;
        }
      }

      if (this.state.current != 'entering' && this.state.current != 'exiting') {
        if (this.state.current != this.state.target) {
          this.run();
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.animator) {
        this.animator.stop();
      }

      if (this.animatorDelay) clearTimeout(this.animatorDelay);
    }
  }, {
    key: "gotAnimationRoot",
    value: function gotAnimationRoot(node) {
      this.animationRoot = node;
    }
  }, {
    key: "run",
    value: function run() {
      var _this5 = this;

      this.setState(function (state) {
        if (state.target == 'in') return {
          current: 'entering'
        };
        return {
          current: 'exiting'
        };
      }, function () {
        _this5.animator = new _animationHelper.default(_this5.speed, _this5.state.current == 'entering' ? _this5.entrance : _this5.exit, function (percent) {
          var pct = _this5.state.current == 'entering' ? percent : 1 - percent;

          _this5.setStyles(_this5.style(_this5.animationRoot, pct));
        }, function () {
          _this5.setStyles(_this5.style(_this5.animationRoot, _this5.state.current == 'entering' ? 1 : 0));

          _this5.animator = null;

          _this5.setState(function (st) {
            return {
              current: st.current == 'entering' ? 'in' : 'out'
            };
          });
        });
        var w = _this5.state.current == 'entering' ? 'delayEnter' : 'delayExit';
        _this5.animatorDelay = setTimeout(function () {
          return _this5.animator.start();
        }, _this5[w]); // this.animator.start();
      });
    }
  }, {
    key: "setStyles",
    value: function setStyles(style) {
      if (this.animationRoot) {
        for (var i in style) {
          this.animationRoot.style[i] = style[i];
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: this.className,
        id: this.id,
        ref: this.gotAnimationRoot
      }, this.state.current == 'out' && this.state.target == 'out' ? null : this.children);
    }
  }], [{
    key: "test",
    value: function test() {
      return {
        _node: document.createElement('div'),
        attach: function attach() {
          document.body.appendChild(this._node);
          Object.assign(this._node.style, {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '500px',
            height: '500px',
            background: '#fff',
            color: '#000',
            padding: '16px'
          });

          _reactDom.default.render( /*#__PURE__*/_react.default.createElement(AnimatedContainer, {
            mode: "out",
            style: function style(node, percent) {
              return {
                opacity: percent
              };
            }
          }, /*#__PURE__*/_react.default.createElement("div", null, "Hello world!")), this._node);
        },
        enter: function enter() {
          _reactDom.default.render( /*#__PURE__*/_react.default.createElement(AnimatedContainer, {
            mode: "in",
            style: function style(node, percent) {
              return {
                opacity: percent
              };
            }
          }, /*#__PURE__*/_react.default.createElement("div", null, "Hello world!")), this._node);
        },
        exit: function exit() {
          _reactDom.default.render( /*#__PURE__*/_react.default.createElement(AnimatedContainer, {
            mode: "out",
            style: function style(node, percent) {
              return {
                opacity: percent
              };
            }
          }, /*#__PURE__*/_react.default.createElement("div", null, "Hello world!")), this._node);
        },
        detach: function detach() {
          _reactDom.default.unmountComponentAtNode(this._node);

          document.body.removeChild(this._node);
        }
      };
    }
  }]);
  return AnimatedContainer;
}(_react.Component), (_descriptor5 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "speed", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 300;
  }
}), _descriptor6 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "delayEnter", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor7 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "delayExit", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor8 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "entrance", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 'ease-in';
  }
}), _descriptor9 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "exit", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 'ease-out';
  }
}), _descriptor10 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "style", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function (node, percent) {
      return {};
    };
  }
}), _descriptor11 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "mode", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 'out';
  }
}), _descriptor12 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "children", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "className", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "id", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "gotAnimationRoot", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "gotAnimationRoot"), _class3.prototype)), _class3);
exports.AnimatedContainer = AnimatedContainer;

var SortByContent = /*#__PURE__*/function (_Component3) {
  babelHelpers.inherits(SortByContent, _Component3);

  var _super3 = _createSuper(SortByContent);

  function SortByContent() {
    var _this6;

    babelHelpers.classCallCheck(this, SortByContent);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this6 = _super3.call.apply(_super3, [this].concat(args));
    _this6.state = {
      baseChildren: _this6.props.children,
      children: _this6.sort(_react.default.Children.toArray(_this6.props.children))
    };
    return _this6;
  }

  babelHelpers.createClass(SortByContent, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.props.children === prevProps.children) return;
      this.setState({
        children: this.sort(_react.default.Children.toArray(this.props.children))
      });
    }
  }, {
    key: "render",
    value: function render() {
      var X = Object.assign({}, this.props);
      var Type = X.type;
      delete X.type;
      delete X.children;
      return /*#__PURE__*/_react.default.createElement(Type, X, this.state.children);
    }
  }, {
    key: "makeString",
    value: function makeString(node) {
      var _this7 = this;

      return _react.default.Children.map(node.props.children, function (node) {
        if (typeof node == 'string') return node;
        return _this7.makeString(node);
      }).join('');
    }
  }, {
    key: "sort",
    value: function sort(items) {
      var _this8 = this;

      items.sort(function (left, right) {
        var LT = _this8.makeString(left).toLowerCase();

        var RT = _this8.makeString(right).toLowerCase();

        return LT < RT ? -1 : 1;
      });
      return items;
    }
  }]);
  return SortByContent;
}(_react.Component);

var SiteNavigation = (_class5 = /*#__PURE__*/function (_Component4) {
  babelHelpers.inherits(SiteNavigation, _Component4);

  var _super4 = _createSuper(SiteNavigation);

  function SiteNavigation() {
    var _this9;

    babelHelpers.classCallCheck(this, SiteNavigation);

    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    _this9 = _super4.call.apply(_super4, [this].concat(args));
    babelHelpers.initializerDefineProperty(_this9, "searchButton", _descriptor15, babelHelpers.assertThisInitialized(_this9));
    babelHelpers.initializerDefineProperty(_this9, "notificationButton", _descriptor16, babelHelpers.assertThisInitialized(_this9));
    babelHelpers.initializerDefineProperty(_this9, "userProfile", _descriptor17, babelHelpers.assertThisInitialized(_this9));
    babelHelpers.initializerDefineProperty(_this9, "loginPrefix", _descriptor18, babelHelpers.assertThisInitialized(_this9));
    babelHelpers.initializerDefineProperty(_this9, "signUpText", _descriptor19, babelHelpers.assertThisInitialized(_this9));
    babelHelpers.initializerDefineProperty(_this9, "signInText", _descriptor20, babelHelpers.assertThisInitialized(_this9));
    babelHelpers.initializerDefineProperty(_this9, "hasSearch", _descriptor21, babelHelpers.assertThisInitialized(_this9));
    babelHelpers.initializerDefineProperty(_this9, "hasCreateAccount", _descriptor22, babelHelpers.assertThisInitialized(_this9));
    babelHelpers.initializerDefineProperty(_this9, "menuToggle", _descriptor23, babelHelpers.assertThisInitialized(_this9));
    babelHelpers.initializerDefineProperty(_this9, "showBackButton", _descriptor24, babelHelpers.assertThisInitialized(_this9));
    babelHelpers.initializerDefineProperty(_this9, "hasPrevious", _descriptor25, babelHelpers.assertThisInitialized(_this9));
    _this9.state = {
      profile: _this9.userProfile,
      menuOpen: null,
      notificationsOpen: false,
      navDown: true,
      navTop: 0,
      hasPaymentMethods: null,
      profileChanged: true,
      profileWithStatus: null,
      pendingAssignments: null,
      allAssignments: null,
      pendingEvents: null,
      allEvents: null,
      pendingApplications: null,
      allApplications: null
    };
    _this9.lastScrollPosition = 0;
    return _this9;
  }

  babelHelpers.createClass(SiteNavigation, [{
    key: "updateEvents",
    value: function updateEvents(event) {
      var _this10 = this;

      if (this._updateEventTimer || event && event.isFetchMore) return;
      this._updateEventTimer = setTimeout(function () {
        Promise.all([(0, _fetch.default)("data/notifications/feeds/events?limit=0").then(function (value) {
          return value.json();
        }), (0, _fetch.default)("data/notifications/feeds/events?filter=eventStartingSoon").then(function (value) {
          return value.json();
        })]).then(function (_ref) {
          var _ref2 = babelHelpers.slicedToArray(_ref, 2),
              value = _ref2[0],
              startingSoon = _ref2[1];

          _this10.setState({
            allEvents: value,
            pendingEvents: _this10.filterFeedItems(value, function (item) {
              if (item.child_type == 'eventFinished') return false;

              if (item.child_type == 'eventStartingSoon') {
                var t = startingSoon.feed.filter(function (e) {
                  return e.id == item.id;
                })[0];
                if (t) return t.startingAt > 3600000 + Date.now();
              }

              return true;
            })
          });

          _this10._updateEventTimer = null;
        });
      }, 250);
    }
  }, {
    key: "updateApplications",
    value: function updateApplications(event) {
      var _this11 = this;

      if (this._updateApplicationTimer || event && event.isFetchMore) return;
      this._updateApplicationTimer = setTimeout(function () {
        (0, _fetch.default)("data/notifications/feeds/applications?limit=0").then(function (value) {
          return value.json();
        }).then(function (value) {
          _this11.setState({
            allApplications: value,
            pendingApplications: _this11.filterFeedItems(value, function (item) {
              return item.child_type == 'applicationSubmitted';
            })
          });

          _this11._updateApplicationTimer = null;
        });
      }, 250);
    }
  }, {
    key: "updateAssignments",
    value: function updateAssignments(event) {
      var _this12 = this;

      if (this._updateAssignmentTimer) return;
      if (event && event.isFetchMore) return;
      this._updateAssignmentTimer = setTimeout(function () {
        (0, _fetch.default)('data/notifications/feeds/assignments?limit=0').then(function (value) {
          return value.json();
        }).then(function (value) {
          _this12.setState({
            allAssignments: value,
            pendingAssignments: _this12.filterFeedItems(value, function (item) {
              return !/Finished/.test(item.child_type);
            })
          });

          _this12._updateAssignmentTimer = null;
        });
      }, 250);
    }
  }, {
    key: "filterFeedItems",
    value: function filterFeedItems(inFeed, itemCallback) {
      var items = inFeed.items,
          outObject = babelHelpers.objectWithoutProperties(inFeed, _excluded);
      outObject.items = items.filter(itemCallback);
      return outObject;
    }
  }, {
    key: "filterFeed",
    value: function filterFeed(inFeed, itemCallback) {
      var feed = inFeed.feed,
          items = inFeed.items,
          outObject = babelHelpers.objectWithoutProperties(inFeed, _excluded2);
      outObject.feed = feed.filter(itemCallback);
      var ids = outObject.feed.map(function (item) {
        return item.id;
      });
      outObject.items = items.filter(function (item) {
        return ids.indexOf(item.id) != -1;
      });
      return outObject;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this13 = this;

      $(document).on('profileUpdated', function (event) {
        if (event.passedState) {
          var state = event.passedState;
          var evt;
          if (state.isNewAccount === true) evt = 'account-created';else if (state.isNewAccount === false) evt = 'signed-in';

          if (evt) {
            (0, _eventDispatcher.default)(evt, profile);
          }
        }

        _this13.setState(function (st) {
          return {
            profile: event.profile,
            profileChanged: true,
            menuOpen: st.menuOpen === true || st.menuOpen === false ? false : null,
            pendingAssignments: null,
            allAssignments: null,
            pendingEvents: null,
            allEvents: null,
            pendingApplications: null,
            allApplications: null
          };
        });

        _this13.updateAssignments();

        _this13.updateEvents();

        _this13.updateApplications();
      });

      if (!this.state.profile) {
        this.updateProfile(null);
      }

      document.addEventListener('scroll', this.onScroll, {
        passive: false
      });
      this.lastScrollPosition = Math.max(0, (document.scrollingElement || document.documentElement).scrollTop || document.body.scrollTop);
      this.onScroll();
      var map = {
        documentSubmitted: this.updateAssignments,
        eventTimeComment: this.updateEvents,
        eventTimeRejected: this.updateEvents,
        eventTimeAccepted: this.updateEvents,
        eventTimeSuggested: this.updateEvents,
        videoSubmitted: this.updateAssignments,
        applicationSubmitted: this.updateApplications
      };

      for (var event in map) {
        _Listener.default.addEventListener(event, map[event]);

        _Listener.default.addEventListener("updated-".concat(event), map[event]);

        _Listener.default.addEventListener("removed-".concat(event), map[event]);
      }

      this.updateAssignments();
      this.updateEvents();
      this.updateApplications();
    }
  }, {
    key: "onScroll",
    value: function onScroll(event) {
      var currentNavTop = this.state.navTop;
      if (this.state.isAnimated) currentNavTop = this.state.targetNavTop;
      var currentNavBottom = currentNavTop + this.navContainer.offsetHeight;
      var scrollPosition = (document.scrollingElement || document.documentElement).scrollTop || document.body.scrollTop;
      scrollPosition = Math.max(0, scrollPosition); // We've moved down the screen. Don't move the nav bar, or if it's already moving, let it keep going.

      if (scrollPosition > this.lastScrollPosition) {
        // Don't move it.
        this.lastScrollPosition = scrollPosition;
        return;
      } // So we're going up. If it's needing to be animated in, or it's currently being animated in, just change the target poiint.


      if (currentNavBottom < scrollPosition || this.state.isAnimated) {
        // This is a pop-in effect.
        this.setState({
          isAnimated: true,
          targetNavTop: scrollPosition
        });
      } else if (currentNavTop > scrollPosition) {
        // This is a move.
        this.setState({
          navTop: scrollPosition
        });
      }

      this.lastScrollPosition = scrollPosition;
    }
  }, {
    key: "showMenu",
    value: function showMenu(event) {
      this.setState(function (st) {
        return {
          menuOpen: !st.menuOpen
        };
      });
    }
  }, {
    key: "showSearch",
    value: function showSearch(event) {
      _search.default.show();

      event.preventDefault();
      return false;
    }
  }, {
    key: "showHelp",
    value: function showHelp(event) {
      event.persist();
      (0, _fetch.default)("/.clear-cache?customer=poolandspa").then(function (r) {
        return r.text();
      }).then(function () {
        return event.shiftKey ? location.reload() : BLX.reloadStylesheet();
      });
      event.preventDefault();
      return false;
    }
  }, {
    key: "showNotifications",
    value: function showNotifications(event) {
      event.preventDefault();
      return false;
    }
  }, {
    key: "showProfile",
    value: function showProfile(event) {
      if (this.state.menuOpen) {
        _UserProfile.default.show();

        event.preventDefault();
        return false;
      }
    }
  }, {
    key: "logout",
    value: function logout(event) {
      if (this.state.menuOpen) (0, _logout.doLogout)().then(this.loggedOut).then(this.updateProfile);
    }
  }, {
    key: "loggedOut",
    value: function loggedOut(value) {
      (0, _noty.showNotificationText)('You have been signed out.');
      return {
        loggedOut: true
      };
    }
  }, {
    key: "updateProfile",
    value: function updateProfile(state) {
      var _this14 = this;

      if (state && state.modal) state.modal.hide();

      if (state && state.useCustomHome && location.href.split('?').shift() == state.defaultHome) {
        if (history.pushState) {
          history.pushState({}, "", state.useCustomHome);
        }
      }

      (0, _userProfile.userProfileUpdated)(state && state.loggedOut === true).then(function (profile) {
        if (state) {
          var evt;
          if (state.isNewAccount === true) evt = 'account-created';else if (state.isNewAccount === false) evt = 'signed-in';

          if (evt) {
            (0, _eventDispatcher.default)(evt, profile);
          }
        }

        _this14.setState(function (st) {
          return {
            profile: profile,
            menuOpen: st.menuOpen === true || st.menuOpen === false ? false : null
          };
        });
      });
    }
  }, {
    key: "showSignUp",
    value: function showSignUp(event) {
      (0, _LoginForm.show)('sign-up').then(this.updateProfile);
    }
  }, {
    key: "showSignIn",
    value: function showSignIn(event) {
      (0, _LoginForm.show)('sign-in').then(this.updateProfile);
    }
  }, {
    key: "showCourses",
    value: function showCourses(event) {
      if (this.state.menuOpen && event.target.dataset.count != '0') _search.MyCourses.show();
    }
  }, {
    key: "showCollections",
    value: function showCollections(event) {
      if (this.state.menuOpen && event.target.dataset.count != '0') _search.Collections.show();
    }
  }, {
    key: "showSubmissions",
    value: function showSubmissions(event) {
      if (this.state.menuOpen && event.target.dataset.count != '0') _search.Submissions.show();
    }
  }, {
    key: "showFavorites",
    value: function showFavorites(event) {
      if (this.state.menuOpen && event.target.dataset.count != '0') _search.Favorites.show();
    }
  }, {
    key: "showGroups",
    value: function showGroups(event) {
      if (this.state.menuOpen && event.target.dataset.count != '0') _search.Groups.show();
    }
  }, {
    key: "showEvents",
    value: function showEvents(event) {
      if (this.state.menuOpen && event.target.dataset.count != '0') _search.Events.show();
    }
  }, {
    key: "showFollowing",
    value: function showFollowing(event) {
      if (this.state.menuOpen && event.target.dataset.count != '0') _search.Following.show();
    }
  }, {
    key: "showRewards",
    value: function showRewards(event) {
      if (this.state.menuOpen && 'count' in event.target.dataset && event.target.dataset.count != '0') {
        var tgt = event.target.dataset.id;
        var item = this.state.profileWithStatus.status.rewardItems.filter(function (item) {
          return item.id == tgt;
        })[0];

        _search.RewardsModal.modalForId(item.id, item.title, item.icon).show();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this15 = this;

      if (prevState.menuOpen != this.state.menuOpen) {
        if (this.state.menuOpen) {
          document.addEventListener('click', this.documentClicked);

          if (this.state.hasPaymentMethods === null) {
            (0, _fetch.default)('purchase/stripe/account').then(function (result) {
              return result.json();
            }).then(function (result) {
              if (_this15.requireAddress) {
                var x = Object.assign({}, result);
                x.sources = x.sources.filter(function (source) {
                  return source.owner && source.owner.address && source.owner.address.line1;
                });
                if (x.sources.filter(function (v) {
                  return v.id == x.defaultSource;
                }).length == 0) x.defaultSource = null;
                result = x;
              }

              if (result.sources.length) {
                _this15.setState({
                  hasPaymentMethods: true
                });
              } else {
                _this15.setState({
                  hasPaymentMethods: false
                });
              }
            });
          }
        } else {
          document.removeEventListener('click', this.documentClicked);
        }
      }

      if (!prevState.isAnimated && this.state.isAnimated) {
        this.animation = new _animationHelper.default(300, 'ease-in', function (pct) {
          var tp = _this15.state.targetNavTop - _this15.navContainer.offsetHeight * (1 - pct);

          _this15.setState({
            navTop: tp
          });
        }, function () {
          _this15.animation = null;

          _this15.setState(function (st) {
            return {
              isAnimated: false,
              navTop: st.targetNavTop
            };
          });
        });
        this.animation.start();
      } else if (this.animation && !this.state.isAnimated) {
        this.animation.stop();
      }

      if (this.state.menuOpen && this.state.profileChanged) {
        this.updateProfileStatus();
      }
    }
  }, {
    key: "updateProfileStatus",
    value: function updateProfileStatus() {
      var _this16 = this;

      (0, _fetch.default)('userProfile').then(function (r) {
        return r.json();
      }).then(function (r) {
        return _this16.setState({
          profileWithStatus: r,
          profileChanged: false
        });
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.menuOpen) {
        document.removeEventListener('click', this.documentClicked);
      }

      var map = {
        documentSubmitted: this.updateAssgnments,
        eventTimeComment: this.updateEvents,
        eventTimeRejected: this.updateEvents,
        eventTimeAccepted: this.updateEvents,
        eventTimeSuggested: this.updateEvents,
        videoSubmitted: this.updateAssignments,
        applicationSubmitted: this.updateApplications
      };

      for (var event in map) {
        _Listener.default.removeEventListener(event, map[event]);

        _Listener.default.removeEventListener("updated-".concat(event), map[event]);

        _Listener.default.removeEventListener("removed-".concat(event), map[event]);
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      if ('top' in newProps && 'top' in this.props && this.props.top != newProps.top) {
        this.setState({
          navTop: newProps.top
        });
      }
    }
  }, {
    key: "documentClicked",
    value: function documentClicked(event) {
      this.setState({
        menuOpen: false
      });
    }
  }, {
    key: "gotNavContainer",
    value: function gotNavContainer(node) {
      this.navContainer = node;
    }
  }, {
    key: "showPayments",
    value: function showPayments() {
      if (this.state.menuOpen) (0, _PaymentsModal.show)();
    }
  }, {
    key: "showPaymentMethods",
    value: function showPaymentMethods() {
      if (this.state.menuOpen) {
        (0, _PaymentMethodsModal.show)();
      }
    }
  }, {
    key: "showApplications",
    value: function showApplications() {
      if (this.state.menuOpen) new _Viewer.InstructorNotificationViewer("data/notifications/feeds/applications", 'Applications', 'ballot').show();
    }
  }, {
    key: "showGrading",
    value: function showGrading() {
      if (this.state.menuOpen) new _Viewer.InstructorNotificationViewer("data/notifications/feeds/assignments", 'Assignments', 'grading').show();
    }
  }, {
    key: "showPendingEvents",
    value: function showPendingEvents() {
      if (this.state.menuOpen) new _Viewer.InstructorNotificationViewer("data/notifications/feeds/events", 'Events', 'events').show();
    }
  }, {
    key: "goBack",
    value: function goBack() {
      history.back();
    }
  }, {
    key: "getBackButtonStyle",
    value: function getBackButtonStyle(node, percent) {
      return {
        transform: "translateX(".concat(percent * 100, "%)")
      };
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "navigation-placeholder"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: _classList.default.join('navigation-container'),
        ref: this.gotNavContainer,
        style: {
          top: this.state.navTop + 'px',
          '--bga': Math.min(this.state.navTop, 10) / 10
        }
      }, this.props.menuItems.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
        className: "nav-left"
      }, this.props.menuItems.length > 0 && /*#__PURE__*/_react.default.createElement("a", {
        href: "javascript:void(0)",
        className: "menu-icon",
        onClick: this.menuToggle
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: this.props.menuButton
      })), /*#__PURE__*/_react.default.createElement(AnimatedContainer, {
        delayEnter: 300,
        delayExit: 300,
        mode: this.props.hasPrevious && this.props.showBackButton ? 'in' : 'out',
        className: "back-button-container",
        style: this.getBackButtonStyle
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: "javascript:void(0)",
        className: "back-button",
        onClick: this.goBack
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icons",
        "data-icon": "arrow_back"
      }), "Back"))), /*#__PURE__*/_react.default.createElement("div", {
        className: "nav-logo center"
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: this.props.homeLink
      }, /*#__PURE__*/_react.default.createElement("img", {
        className: "logo desktop",
        src: this.props.desktopLogo,
        alt: this.props.companyName
      }), /*#__PURE__*/_react.default.createElement("img", {
        className: "logo mobile",
        src: this.props.mobileLogo,
        alt: this.props.companyName
      }))), this.renderCenterNav(), this.renderSiteNav()));
    }
  }, {
    key: "showInstructorTools",
    value: function showInstructorTools() {
      var x = (this.state.allAssignments || {
        items: []
      }).items.length;
      x += (this.state.allEvents || {
        items: []
      }).items.length;
      x += (this.state.allApplications || {
        items: []
      }).items.length;
      return x > 0;
    }
  }, {
    key: "renderExtraElements",
    value: function renderExtraElements() {
      return null;
    }
  }, {
    key: "renderCenterNav",
    value: function renderCenterNav() {
      return null;
    }
  }, {
    key: "renderSiteNav",
    value: function renderSiteNav() {
      var _this17 = this;

      if (this.state.profile && !this.state.profile.guest) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "nav-right"
        }, /*#__PURE__*/_react.default.createElement("div", null, this.renderExtraElements(), this.hasSearch && /*#__PURE__*/_react.default.createElement("a", {
          title: "Search",
          className: "icon search",
          href: "javascript:void(0)",
          onClick: this.showSearch
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: "material-icons",
          "data-icon": "search"
        }), /*#__PURE__*/_react.default.createElement("span", {
          className: "sr-only"
        }, "Search")), /*#__PURE__*/_react.default.createElement("a", {
          title: "Help",
          className: "icon search",
          href: "help"
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: "material-icons",
          "data-icon": "question_mark"
        }), /*#__PURE__*/_react.default.createElement("span", {
          className: "sr-only"
        }, "Help")), /*#__PURE__*/_react.default.createElement(_ProfileImageContainer.default, {
          componentName: "a",
          className: "icon menu",
          imageClassName: "image",
          noImageClassName: "",
          attributes: {
            title: 'My Account',
            id: 'myAccountLink',
            href: "javascript:void(0)",
            onClick: this.showMenu
          },
          image: this.state.profile.photo,
          name: this.state.profile.nickname || this.state.profile.fullName
        }), /*#__PURE__*/_react.default.createElement("div", {
          className: _classList.default.join('nav-dropdown', this.state.menuOpen ? 'open' : '', this.state.menuOpen === false ? 'closed' : '')
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "top"
        }, /*#__PURE__*/_react.default.createElement("p", {
          className: "name",
          id: "myAccountName"
        }, this.state.profile.nickname || this.state.profile.fullName)), false ? /*#__PURE__*/_react.default.createElement(SortByContent, {
          type: "div",
          className: "middle"
        }, this.state.profile.system.hasCollections && /*#__PURE__*/_react.default.createElement("a", {
          className: "menu-item2 collections",
          onClick: this.showCollections,
          "data-count": (this.state.profileWithStatus || {
            status: {}
          }).status.collectionCount,
          href: "javascript:void(0)"
        }, "Collections"), this.state.profile.system.hasCourses && /*#__PURE__*/_react.default.createElement("a", {
          className: "menu-item2 courses",
          onClick: this.showCourses,
          "data-count": (this.state.profileWithStatus || {
            status: {}
          }).status.courseCount,
          href: "javascript:void(0)"
        }, "Courses"), this.state.profile.system.hasEvents && /*#__PURE__*/_react.default.createElement("a", {
          className: "menu-item2 events",
          onClick: this.showEvents,
          "data-count": (this.state.profileWithStatus || {
            status: {}
          }).status.eventsCount || 0,
          href: "javascript:void(0)"
        }, "Events"), /*#__PURE__*/_react.default.createElement("a", {
          className: "menu-item2 favorites",
          onClick: this.showFavorites,
          "data-count": (this.state.profileWithStatus || {
            status: {}
          }).status.favoriteCount,
          href: "javascript:void(0)"
        }, "Favorites"), this.state.profile.system.hasFollowing && /*#__PURE__*/_react.default.createElement("a", {
          className: "menu-item2 following",
          onClick: this.showFollowing,
          "data-count": (this.state.profileWithStatus || {
            status: {}
          }).status.followingCount || 0,
          href: "javascript:void(0)"
        }, "Following"), this.state.profile.system.hasUserGroups && this.state.profileWithStatus && !!this.state.profileWithStatus.status.groupCount && /*#__PURE__*/_react.default.createElement("a", {
          className: "menu-item2 groups",
          onClick: this.showGroups,
          "data-count": this.state.profileWithStatus.status.groupCount,
          href: "javascript:void(0)"
        }, "Groups"), this.state.profile.system.hasSubmissions && /*#__PURE__*/_react.default.createElement("a", {
          className: "menu-item2 submissions",
          onClick: this.showSubmissions,
          "data-count": (this.state.profileWithStatus || {
            status: {}
          }).status.submissionCount,
          href: "javascript:void(0)"
        }, "Submissions"), (this.state.profileWithStatus || {
          status: {
            rewardItems: []
          }
        }).status.rewardItems.map(function (item) {
          return /*#__PURE__*/_react.default.createElement("a", {
            key: item.id,
            className: _classList.default.join('menu-item2', item.icon.type == 'system' ? item.icon.className : 'user-icon'),
            "data-count": item.itemCount,
            href: "javascript:void(0)",
            "data-id": item.id,
            onClick: _this17.showRewards
          }, item.title);
        })) : null, /*#__PURE__*/_react.default.createElement("div", {
          className: "middle"
        }, /*#__PURE__*/_react.default.createElement("a", {
          className: "menu-item2 profile",
          href: "javascript:void(0)",
          onClick: this.showProfile
        }, "Profile"), /*#__PURE__*/_react.default.createElement("a", {
          className: "menu-item2 sign-out",
          href: "javascript:void(0)",
          onClick: this.logout
        }, "Sign Out")))));
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "nav-right"
      }, /*#__PURE__*/_react.default.createElement("div", null, this.renderExtraElements(), this.hasCreateAccount && this.loginPrefix && /*#__PURE__*/_react.default.createElement("p", {
        className: "login-prefix"
      }, this.loginPrefix), /*#__PURE__*/_react.default.createElement("div", {
        className: "button-container"
      }, /*#__PURE__*/_react.default.createElement("a", {
        title: "Sign In",
        className: "sign-in",
        href: "javascript:void(0)",
        onClick: this.showSignIn
      }, /*#__PURE__*/_react.default.createElement("p", null, this.signInText || 'Sign In')), this.hasCreateAccount && /*#__PURE__*/_react.default.createElement("a", {
        title: "Sign Up",
        className: "sign-up",
        href: "javascript:void(0)",
        onClick: this.showSignUp
      }, /*#__PURE__*/_react.default.createElement("p", null, this.signUpText || 'Sign Up'))), this.hasSearch && /*#__PURE__*/_react.default.createElement("a", {
        title: "Search",
        className: "icon search",
        href: "javascript:void(0)",
        onClick: this.showSearch
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icons",
        "data-icon": "search"
      }), /*#__PURE__*/_react.default.createElement("span", {
        className: "sr-only"
      }, "Search")), /*#__PURE__*/_react.default.createElement(_localize.LocalizeMenu, null), /*#__PURE__*/_react.default.createElement("a", {
        title: "Help",
        className: "icon search",
        href: "help"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icons",
        "data-icon": "question_mark"
      }), /*#__PURE__*/_react.default.createElement("span", {
        className: "sr-only"
      }, "Help"))));
    }
  }, {
    key: "showAdditionalInstructorTools",
    value: function showAdditionalInstructorTools() {
      return null;
    }
  }]);
  return SiteNavigation;
}(_react.Component), (_descriptor15 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "searchButton", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "notificationButton", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "userProfile", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor18 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "loginPrefix", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "signUpText", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "signInText", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "hasSearch", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor22 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "hasCreateAccount", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor23 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "menuToggle", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor24 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "showBackButton", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor25 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "hasPrevious", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "updateEvents", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "updateEvents"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "updateApplications", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "updateApplications"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "updateAssignments", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "updateAssignments"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "onScroll", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "onScroll"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "showMenu", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "showMenu"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "showSearch", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "showSearch"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "showHelp", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "showHelp"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "showNotifications", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "showNotifications"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "showProfile", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "showProfile"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "logout", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "logout"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "loggedOut", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "loggedOut"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "updateProfile", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "updateProfile"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "showSignUp", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "showSignUp"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "showSignIn", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "showSignIn"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "showCourses", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "showCourses"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "showCollections", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "showCollections"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "showSubmissions", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "showSubmissions"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "showFavorites", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "showFavorites"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "showGroups", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "showGroups"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "showEvents", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "showEvents"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "showFollowing", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "showFollowing"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "showRewards", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "showRewards"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "documentClicked", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "documentClicked"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "gotNavContainer", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "gotNavContainer"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "showPayments", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "showPayments"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "showPaymentMethods", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "showPaymentMethods"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "showApplications", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "showApplications"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "showGrading", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "showGrading"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "showPendingEvents", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "showPendingEvents"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "goBack", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "goBack"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "getBackButtonStyle", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "getBackButtonStyle"), _class5.prototype)), _class5);
exports.default = SiteNavigation;